module.exports = __webpack_public_path__ + "static/icon1-494554f89149f99eff906fb9a1db76ff.png";